import React, {createContext, useReducer} from "react";
import {DeliveryWindowConfigReducer} from "../reducer/DeliveryWindowConfigReducer";
import {DEFAULT_ALERT} from "../Constants";

export const DeliveryWindowConfigContext = createContext();

const DeliveryWindowConfigContextProvider = (props) => {
    const deliveryWindowConfigConfiguration = {
        cycleList: [],
        packageCycleConfig: {},
        alert: DEFAULT_ALERT,
        loadingCycle: true,
        loadingConfig: true,
        isEditable: false
    }

    const [viewModel, dispatch ] = useReducer(DeliveryWindowConfigReducer, deliveryWindowConfigConfiguration)
    return (
        <DeliveryWindowConfigContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </DeliveryWindowConfigContext.Provider>
    )
}

export default DeliveryWindowConfigContextProvider


// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/context/DeliveryWindowConfigContext.js